import Header from "components/Headers/Header";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchBids } from "store/actions/vendorActions";
import { approveBid } from "store/actions/vendorActions";
import { rejectBid } from "store/actions/vendorActions";
import { reportBidIssue } from "store/actions/vendorActions";
import { fetchVendorById } from "store/actions/vendorActions";
import TableComponent from "components/TableComponent";
import { revertBid } from "store/actions/vendorActions";
import { toast } from "react-toastify";
import { fetchBidRequestsStats } from "store/actions/vendorActions";
import moment from "moment";
import { getHistoryBids } from "store/actions/vendorActions";
import { getSubstituteRequests } from "store/actions/vendorActions";
import { rejectSubstituteRequest } from "store/actions/vendorActions";
import { acceptSubstituteRequest } from "store/actions/vendorActions";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import vendorImg from "../../assets/img/custom/vendor.jpg";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import { fetchVendorsForBids } from "store/actions/vendorActions";

const Bids = () => {
  const dispatch = useDispatch();
  const {
    vendors,
    vendor,
    bids,
    bidStats,
    lastDoc,
    hasMore,
    isFetching,
    isFetchingVendor,
    actionLoading,
    bidHistory,
    substituteRequests,
    vendorsForBids,
  } = useSelector((state) => state.vendor);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const sanitizedType = type ? type.replace(/^['"]|['"]$/g, "") : "bidRequests";
  const [activeTab, setActiveTab] = useState(sanitizedType);
  const [activeCategory, setActiveCategory] = useState("TL");
  const [activeCategoryStats, setActiveCategoryStats] = useState({
    approved: 0,
    reserved: 0,
  });
  const [actionType, setActionType] = useState("");
  const [activeBidId, setActiveBidId] = useState(null);
  const [activeVendor, setActiveVendor] = useState(null);
  const [issueMode, setIssueMode] = useState("");
  const [vendorModal, setVendorModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [issueModal, setIssueModal] = useState(false);
  const [issue, setIssue] = useState("");

  const [filter, setFilter] = useState({
    bid: "",
    status: "",
  });

  const bidCategories = ["TL", "FB", "PCHG", "ET", "RT", "TEC", "OT"];
  const APPROVED_BIDS_LIMIT = 20;
  const RESERVED_BIDS_LIMIT = 5;
  const bidsInfoPoints = [
    "Review new bids submitted by vendors in the Bid Requests tab.",
    "Accept or reject bids based on platform criteria.",
    "Manage accepted bids in the Accepted Bids tab.",
    "Oversee bids that are currently live in the Active Bids tab.",
    "Maintain a complete record of past bids in the History tab.",
    "Review and take action on vendor-initiated change requests in the Substitute Requests tab.",
  ];
  const subPoints = [
    {
      title: "Bids Request",
      description:
        "Displays newly submitted bids from vendors. Users can create bids under various categories, including TL, FB, PCHG, ET, RT, TEC, and OT. The admin reviews each bid and decides to accept or reject it.",
    },
    {
      title: "Accepted Bids",
      description:
        "Bids that have been approved by the admin are moved to this tab and waiting for the date to be published on FHP platform.",
    },
    {
      title: "Active Bids",
      description:
        "Bids that are currently live on the FHP platform (based on their scheduled dates) are displayed here.",
    },
    {
      title: "History",
      description:
        "This tab contains complete records and details of all past bids for reference and tracking.",
    },
    {
      title: "Substitute Requests",
      description:
        "Vendors can request changes to their existing bids, and those requests are shown here for the admin to review and take action.",
    },
  ];

  const bidsInfoTitle = "Bids Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const Bids = bids
    ?.filter((bid) => {
      if (activeTab === "bidRequests") {
        const matchingVendor = vendorsForBids.find(
          (vendor) => vendor.uid === bid.vendorId
        );
        return matchingVendor?.status === "approved";
      }
      return true;
    })
    .map((bid) => ({
      ...bid,
      bid: `${bid?.bid}$`,
      createdAt: new Date(bid.createdAt.seconds * 1000).toLocaleDateString(
        "en-US"
      ),
      updatedAt: new Date(bid.updatedAt.seconds * 1000).toLocaleDateString(
        "en-US"
      ),
      setDescription: (
        <span
          className={`tooltip-container fw-normal ${
            bid?.description.length > 21 ? "pointer" : ""
          }`}
        >
          {bid?.description.length > 21
            ? bid?.description.slice(0, 22) + "..."
            : bid?.description}

          {bid?.description.length > 21 && (
            <span className="tooltip-text">{bid?.description}</span>
          )}
        </span>
      ),
      videoOrImage:
        bid?.bidType == "image" ? (
          <img src={bid.imageUrl} alt="bid img" width="130" height="75" />
        ) : (
          <video width="130" height="75" controls>
            <source src={bid.videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ),
    }));

  const columns = [
    "Category",
    "Video/Image",
    "Bid Type",
    "Bid",
    "Description",
    "Website",
    activeTab === "bidRequests" ? "Date of Request" : "Date of Approval",
    "Status",
  ];
  const columnsHistory = [
    "Category",
    "Video/Image",
    "Bid Type",
    "Bid",
    "Description",
    "Website",
    "Total Views",
    "Date of Approval",
    "Status",
  ];
  const columnsSubstitute = [
    "Category",
    "Video/Image",
    "Bid Type",
    "Reason",
    "Description",
    "Website",
    "CreatedAt",
    "Status",
  ];
  const keyMapHistory = {
    Category: "category",
    "Video/Image": "videoOrImage",
    "Bid Type": "bidType",
    Bid: "bid",
    Description: "setDescription",
    Website: "website",
    "Total Views": "total_views",
    "Date of Approval": "createdAt",
    CreatedAt: "createdAt",
    Reason: "setReason",
    Status: "status",
  };

  const keyMap = {
    Category: "category",
    "Video/Image": "videoOrImage",
    "Bid Type": "bidType",
    Bid: "bid",
    Description: "setDescription",
    Website: "website",
    ...(activeTab === "bidRequests"
      ? { "Date of Request": "createdAt" }
      : { "Date of Approval": "createdAt" }),
    Status: "status",
  };

  const renderActions = (bid) => (
    <div className="text-center">
      <Button
        color="primary"
        size="sm"
        onClick={() => fetchVendorDetails(bid?.vendorId)}
      >
        Vendor Details
      </Button>
      {bid?.status !== "payment_pending" && bid?.status !== "reserved" ? (
        <>
          {bid?.status !== "issue" && (
            <Button
              color="success"
              size="sm"
              onClick={() =>
                intiateBidAction(
                  activeCategoryStats?.approved < APPROVED_BIDS_LIMIT
                    ? "approve"
                    : "reserve",
                  bid?.id,
                  bid?.vendorId
                )
              }
            >
              {activeCategoryStats?.approved < APPROVED_BIDS_LIMIT
                ? "Approve"
                : "Reserve"}
            </Button>
          )}
          <Button
            color="warning"
            size="sm"
            onClick={() => {
              setIssue(bid?.issue);
              intiateBidAction("issue", bid?.id, bid?.vendorId, bid?.status);
            }}
          >
            {bid?.status === "pending" ? "Report" : "View"} Issue
          </Button>
          {bid?.status === "resolved" && (
            <Button
              color="warning"
              size="sm"
              onClick={() => {
                intiateBidAction("issue", bid?.id, bid?.vendorId, "pending");
              }}
            >
              Report Issue
            </Button>
          )}
          <Button
            color="danger"
            size="sm"
            onClick={() => intiateBidAction("reject", bid?.id, bid?.vendorId)}
          >
            Reject
          </Button>
        </>
      ) : (
        <Button
          color="danger"
          size="sm"
          onClick={() => intiateBidAction("revert", bid?.id, bid?.vendorId)}
        >
          Revert
        </Button>
      )}
    </div>
  );
  const [substitution, setSubstitution] = useState({
    modal: false,
    accept: false,
    btnLoader: false,
    collectionId: "",
  });
  const toggleSubstitution = () => {
    setSubstitution((prev) => ({
      ...prev,
      modal: !prev.modal,
    }));
  };
  const handleSubstitutionAction = (id, condition) => {
    setSubstitution((prev) => ({
      ...prev,
      modal: true,
      accept: condition,
      collectionId: id,
    }));
  };
  const handleSubstitution = () => {
    setSubstitution((prev) => ({
      ...prev,
      btnLoader: true,
    }));
    if (substitution.accept) {
      dispatch(
        acceptSubstituteRequest(substitution.collectionId, () => {
          setSubstitution((prev) => ({
            ...prev,
            modal: false,
            accept: false,
            collectionId: "",
            btnLoader: false,
          }));
        })
      );
    } else {
      dispatch(
        rejectSubstituteRequest(substitution.collectionId, () => {
          setSubstitution((prev) => ({
            ...prev,
            modal: false,
            accept: false,
            collectionId: "",
            btnLoader: false,
          }));
        })
      );
    }
  };
  const renderActionsSubstitution = (bid) => (
    <div className="text-center">
      <Button
        size="sm"
        color="primary"
        onClick={() => handleSubstitutionAction(bid.id, true)}
      >
        Accept
      </Button>
      <Button
        size="sm"
        color="danger"
        onClick={() => handleSubstitutionAction(bid.id, false)}
      >
        Reject
      </Button>
    </div>
  );

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const toggleCategory = (category) => {
    if (activeCategory !== category) {
      setActiveCategory(category);
    }
  };

  const vendorModalToggler = () => {
    setVendorModal(!vendorModal);
  };

  const confirmationModalToggler = () => {
    if (confirmationModal) {
      setActiveBidId(null);
      setActionType("");
    }
    setConfirmationModal(!confirmationModal);
  };

  const issueModalToggler = () => {
    if (issueModal) {
      setActiveBidId(null);
      setIssue("");
    }
    setIssueModal(!issueModal);
  };

  const intiateBidAction = (type, bidId, vendorId, status = "") => {
    const vendor = vendorsForBids.find((vendor) => vendor?.uid === vendorId);
    setActiveVendor(vendor);
    setActiveBidId(bidId);
    setActionType(type);
    if (
      type === "approve" ||
      type === "reserve" ||
      type === "reject" ||
      type === "revert"
    ) {
      confirmationModalToggler();
    } else {
      setIssueMode(status === "pending" ? "report" : "view");
      issueModalToggler();
    }
  };

  const handleAprroveReserveBid = (payload) => {
    if (
      actionType === "approve" &&
      activeCategoryStats?.approved < APPROVED_BIDS_LIMIT
    ) {
      dispatch(
        approveBid({
          bidId: activeBidId,
          status: "payment_pending",
          payload,
          onSuccess: () => {
            confirmationModalToggler();
          },
        })
      );
    } else if (
      actionType === "reserve" &&
      activeCategoryStats?.reserved < RESERVED_BIDS_LIMIT
    ) {
      dispatch(
        approveBid({
          bidId: activeBidId,
          status: "reserved",
          payload,
          onSuccess: () => {
            confirmationModalToggler();
          },
        })
      );
    } else {
      toast.info(
        `Limit reached. ${APPROVED_BIDS_LIMIT} approved, ${RESERVED_BIDS_LIMIT} reserved. Please revert any to perform the action.`
      );
      confirmationModalToggler();
    }
  };

  const handleBidAction = () => {
    if (activeBidId) {
      const payload = {
        username: activeVendor?.name,
        email: activeVendor?.email,
        category: activeCategory,
      };
      if (actionType === "approve" || actionType === "reserve") {
        handleAprroveReserveBid(payload);
      } else if (actionType === "reject") {
        dispatch(
          rejectBid({
            bidId: activeBidId,
            payload,
            onSuccess: confirmationModalToggler,
          })
        );
      } else {
        dispatch(
          revertBid({
            bidId: activeBidId,
            currentStatus: bids.find((bid) => bid?.id === activeBidId).status,
            payload,
            onSuccess: () => {
              confirmationModalToggler();
            },
          })
        );
      }
    }
  };

  const handleBidIssue = (e) => {
    e.preventDefault();
    if (activeBidId) {
      dispatch(
        reportBidIssue({
          bidId: activeBidId,
          reason: issue,
          onSuccess: issueModalToggler,
        })
      );
    }
  };

  const fetchVendorDetails = (vendorId) => {
    vendorModalToggler();
    dispatch(
      fetchVendorById({
        vendorId,
        onError: vendorModalToggler,
      })
    );
  };

  const handleClearFilter = () => {
    setFilter({
      bid: "",
      status: "",
    });
    dispatch(
      fetchBids(null, activeTab, activeTab === "bidRequests" && activeCategory)
    );
  };

  const handleApplyFilter = () => {
    dispatch(
      fetchBids(
        null,
        activeTab,
        activeTab === "bidRequests" && activeCategory,
        filter
      )
    );
  };

  const loadMoreBids = () => {
    dispatch(
      fetchBids(
        lastDoc,
        activeTab,
        activeTab === "bidRequests" && activeCategory
      )
    );
  };

  useEffect(() => {
    if (bids?.length > 0) {
      let approvedCount = 0;
      let reservedCount = 0;

      bids.forEach((bid) => {
        if (bid.status === "payment_pending") {
          approvedCount += 1;
        } else if (bid.status === "reserved") {
          reservedCount += 1;
        }
      });

      setActiveCategoryStats({
        approved: approvedCount,
        reserved: reservedCount,
      });
    } else {
      setActiveCategoryStats({
        approved: 0,
        reserved: 0,
      });
    }
  }, [bids, activeCategory]);

  useEffect(() => {
    dispatch(
      fetchVendorsForBids("", () => {
        dispatch(
          fetchBids(
            null,
            activeTab,
            activeTab === "bidRequests" && activeCategory
          )
        );
      })
    );
  }, [activeTab, activeCategory]);

  useEffect(() => {
    setFilter({
      bid: "",
      status: "",
    });
  }, [activeCategory]);

  useEffect(() => {
    if (activeTab === "bidRequests") {
      dispatch(fetchBidRequestsStats());
    }
  }, []);
  const formattedHistory = (data) => {
    return data?.map((item) => ({
      ...item,
      createdAt: moment.unix(item?.createdAt?.seconds).format("DD-MM-YYYY"),
      videoOrImage:
        item?.bidType == "image" ? (
          <img src={item.imageUrl} alt="bid img" width="130" height="75" />
        ) : (
          <video width="130" height="75" controls>
            <source src={item.videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ),
      setDescription: (
        <span
          className={`tooltip-container fw-normal ${
            item?.description.length > 21 ? "pointer" : ""
          }`}
        >
          {item?.description.length > 21
            ? item?.description.slice(0, 22) + "..."
            : item?.description}

          {item?.description.length > 21 && (
            <span className="tooltip-text">{item?.description}</span>
          )}
        </span>
      ),
      setReason: item?.reason ? (
        <span
          className={`tooltip-container fw-normal ${
            item?.reason.length > 21 ? "pointer" : ""
          }`}
        >
          {item?.reason.length > 21
            ? item?.reason.slice(0, 22) + "..."
            : item?.reason}

          {item?.reason.length > 21 && (
            <span className="tooltip-text">{item?.reason}</span>
          )}
        </span>
      ) : (
        ""
      ),
    }));
  };

  const [selectedMonthYear, setSelectedMonthYear] = useState(
    moment().format("YYYY-MM")
  );
  const [historyLoader, setHistoryLoader] = useState({
    btn: false,
    data: false,
  });
  const [substituteLoader, setSubstituteLoader] = useState({
    btn: false,
    data: false,
  });

  const handleMonthChange = (event) => {
    setSelectedMonthYear(event.target.value);
  };

  const handleHistory = () => {
    setHistoryLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getHistoryBids(selectedMonthYear, () => {
        setHistoryLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const handleGetSubstituteRequest = () => {
    setSubstituteLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getSubstituteRequests(() => {
        setSubstituteLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const handleFilterHistory = () => {
    setHistoryLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      getHistoryBids(selectedMonthYear, () => {
        setHistoryLoader((prev) => ({
          ...prev,
          btn: false,
        }));
      })
    );
  };

  return (
    <>
      <Header />
      <Container className="mt-2 mb-4" fluid>
        <Card className="shadow overflow-hidden">
          <Nav
            tabs
            className="d-flex justify-content-start text-dark athlete_earning-nav"
          >
            <NavItem>
              <NavLink
                id="BidRequestsTooltip"
                className={
                  activeTab === "bidRequests"
                    ? "active active-tab py-2 bg-primary "
                    : "text-dark cursor-pointer py-2 "
                }
                onClick={() => toggleTab("bidRequests")}
              >
                <h2
                  className={activeTab === "bidRequests" && "text-white"}
                  onClick={() => toggleTab("bidRequests")}
                >
                  Bid Requests
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                id="AcceptedBidsTooltip"
                className={
                  activeTab === "acceptedBids"
                    ? "active active-tab py-2 bg-primary"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => toggleTab("acceptedBids")}
              >
                <h2 className={activeTab === "acceptedBids" && "text-white"}>
                  Accepted Bids
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                id="ActiveBidsTooltip"
                className={
                  activeTab === "activeBids"
                    ? "active active-tab py-2 bg-primary"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => toggleTab("activeBids")}
              >
                <h2 className={activeTab === "activeBids" && "text-white"}>
                  Active Bids
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                id="HistoryTooltip"
                className={
                  activeTab === "history"
                    ? "active active-tab py-2 bg-primary"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => {
                  toggleTab("history");
                  handleHistory();
                }}
              >
                <h2 className={activeTab === "history" && "text-white"}>
                  History
                </h2>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                id="SubstituteRequestsTooltip"
                className={
                  activeTab === "substitute-requests"
                    ? "active active-tab py-2 bg-primary"
                    : "text-dark cursor-pointer py-2"
                }
                onClick={() => {
                  toggleTab("substitute-requests");
                  handleGetSubstituteRequest();
                }}
              >
                <h2
                  className={
                    activeTab === "substitute-requests" && "text-white"
                  }
                >
                  Substitute Requests
                </h2>
              </NavLink>
            </NavItem>
            <h2
              className="mb-0 ml-auto m-2 text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => setInfoModalOpen(true)}
            >
              <i className="fa fa-question-circle" aria-hidden="true"></i>
            </h2>{" "}
          </Nav>
          <TabContent
            activeTab={activeTab}
            className="px-3 pt-3 pb-1 athlete-earning-content"
          >
            <TabPane tabId="bidRequests">
              <Nav
                tabs
                className="mx-2 d-flex justify-content-start text-dark athlete_earning-nav"
              >
                {bidCategories?.map((category, index) => (
                  <NavItem key={index}>
                    <NavLink
                      className={
                        activeCategory === category
                          ? "active active-tab py-2 bg-primary "
                          : "text-dark cursor-pointer py-2 "
                      }
                      onClick={() => toggleCategory(category)}
                    >
                      <h2
                        className={activeCategory === category && "text-white"}
                        onClick={() => toggleCategory(category)}
                      >
                        {category}
                      </h2>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
              <TabContent
                activeTab={activeCategory}
                className="p-3 athlete-earning-content"
              >
                <TabPane tabId={activeCategory}>
                  <h3 className="mb-4">
                    Total Bids:{" "}
                    {bidStats &&
                      (bidStats[activeCategory] ? bidStats[activeCategory] : 0)}
                  </h3>
                  <Form className="p-0 m-0">
                    <Row className="w-100">
                      <Col xs={12} sm={6}>
                        <FormGroup>
                          <Label for="bid">Bid</Label>
                          <Input
                            type="select"
                            id="bid"
                            name="bid"
                            value={filter?.bid}
                            onChange={handleFilterChange}
                          >
                            <option value="">Select Bid Range</option>
                            <option value="Less than 50">Less than 50</option>
                            <option value="51 - 100">51 - 100</option>
                            <option value="100 - 200">100 - 200</option>
                            <option value="200 - 300">200 - 300</option>
                            <option value="Above 300">Above 300</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col xs={12} sm={6}>
                        <FormGroup>
                          <Label for="status">Status</Label>
                          <Input
                            type="select"
                            id="status"
                            name="status"
                            value={filter.status}
                            onChange={handleFilterChange}
                          >
                            <option value="">Select Bid Status</option>
                            <option value="pending">Pending</option>
                            <option value="payment_pending">
                              Payment Pending
                            </option>
                            <option value="issue">Issue</option>
                            <option value="resolved">Resolved</option>
                            <option value="accepted">Accepted</option>
                            <option value="reserved">Reserved</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="w-100">
                      <Col
                        xs={12}
                        className="d-flex flex-column flex-sm-row justify-content-end align-items-center"
                      >
                        <Button
                          color="danger"
                          onClick={handleClearFilter}
                          disabled={isFetching}
                          className="width-res mb-2 mb-sm-0 mr-0 mr-sm-2"
                        >
                          Clear
                        </Button>
                        <Button
                          color="primary"
                          onClick={handleApplyFilter}
                          disabled={isFetching}
                          className="width-res"
                        >
                          Apply
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                  {isFetching ? (
                    <div className="py-5 d-flex justify-content-center">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableComponent
                      columns={columns}
                      data={Bids}
                      keyMap={keyMap}
                      renderActions={renderActions}
                    />
                  )}
                </TabPane>
              </TabContent>
            </TabPane>
            <TabPane tabId="acceptedBids">
              {isFetching ? (
                <div className="py-5 d-flex justify-content-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <TableComponent columns={columns} data={Bids} keyMap={keyMap} />
              )}
            </TabPane>
            <TabPane tabId="activeBids">
              {isFetching ? (
                <div className="py-5 d-flex justify-content-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <TableComponent columns={columns} data={Bids} keyMap={keyMap} />
              )}
            </TabPane>
            <TabPane tabId="history">
              {isFetching ? (
                <div className="py-5 d-flex justify-content-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <div>
                    <Row>
                      <Col
                        xs={12}
                        sm={9}
                        md={8}
                        lg={6}
                        xl={5}
                        className="mb-3 mb-sm-0"
                      >
                        <Label>Select Month:</Label>
                        <Input
                          type="month"
                          onChange={handleMonthChange}
                          value={selectedMonthYear}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={3}
                        md={4}
                        lg={3}
                        xl={2}
                        className="d-flex align-items-end"
                      >
                        <Button
                          onClick={handleFilterHistory}
                          color="primary"
                          disabled={historyLoader.btn}
                          className="w-100"
                        >
                          {historyLoader.btn ? <Spinner size="sm" /> : "Apply"}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  {historyLoader.data ? (
                    <div className="text-center my-4">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableComponent
                      columns={columnsHistory}
                      data={formattedHistory(bidHistory)}
                      keyMap={keyMapHistory}
                    />
                  )}
                </>
              )}
            </TabPane>
            <TabPane tabId="substitute-requests">
              {isFetching ? (
                <div className="py-5 d-flex justify-content-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  {substituteLoader.data ? (
                    <div className="text-center my-4">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableComponent
                      columns={columnsSubstitute}
                      data={formattedHistory(substituteRequests)}
                      keyMap={keyMapHistory}
                      renderActions={renderActionsSubstitution}
                    />
                  )}
                </>
              )}
            </TabPane>
          </TabContent>
          {hasMore && (
            <div className="d-flex justify-content-center py-4">
              <Button
                color="primary"
                onClick={loadMoreBids}
                disabled={isFetching}
              >
                Load More
              </Button>
            </div>
          )}
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={bidsInfoPoints}
        title={bidsInfoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={vendorModal} toggle={vendorModalToggler} centered>
        <ModalHeader className="border-bottom">Vendor Details</ModalHeader>
        <ModalBody>
          {isFetchingVendor ? (
            <div className="d-flex justify-content-center my-5">
              <Spinner />
            </div>
          ) : (
            vendor && (
              <>
                <div className="d-flex flex-column justify-content-center">
                  <img
                    width={96}
                    height={96}
                    src={vendor?.photoURL}
                    className="rounded-circle mx-auto"
                  />
                  <h2 className="mt-2 mb-3 text-center">{vendor?.name}</h2>
                </div>
                <Row className="align-items-center">
                  {/* Email */}
                  <Col xs={12} className="mb-2">
                    <Label style={{ fontWeight: 600 }}>Email: &nbsp;</Label>
                    <Label>{vendor?.email}</Label>
                  </Col>

                  {/* State */}
                  <Col xs={12} className="mb-2">
                    <Label style={{ fontWeight: 600 }}>State: &nbsp;</Label>
                    <Label>{vendor?.state}</Label>
                  </Col>
                </Row>
              </>
            )
          )}
          <div className="d-flex justify-content-end mt-3 mb-2">
            <Button
              color="danger"
              className="me-3"
              onClick={vendorModalToggler}
            >
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={confirmationModal}
        toggle={confirmationModalToggler}
        centered
      >
        <ModalHeader className="border-bottom text-capitalize">
          {actionType} Bid
          {/* {actionType === 'approve' ? 'Approve Bid' : 'Reject Bid'} */}
        </ModalHeader>
        <ModalBody>
          <div className="d-flex align-items-center flex-column text-center">
            <svg
              width={128}
              height={128}
              viewBox="-0.5 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  d="M10.8809 16.15C10.8809 16.0021 10.9101 15.8556 10.967 15.7191C11.024 15.5825 11.1073 15.4586 11.2124 15.3545C11.3175 15.2504 11.4422 15.1681 11.5792 15.1124C11.7163 15.0567 11.8629 15.0287 12.0109 15.03C12.2291 15.034 12.4413 15.1021 12.621 15.226C12.8006 15.3499 12.9399 15.5241 13.0211 15.7266C13.1024 15.9292 13.122 16.1512 13.0778 16.3649C13.0335 16.5786 12.9272 16.7745 12.7722 16.9282C12.6172 17.0818 12.4204 17.1863 12.2063 17.2287C11.9922 17.2711 11.7703 17.2494 11.5685 17.1663C11.3666 17.0833 11.1938 16.9426 11.0715 16.7618C10.9492 16.5811 10.8829 16.3683 10.8809 16.15ZM11.2408 13.42L11.1008 8.20001C11.0875 8.07453 11.1008 7.94766 11.1398 7.82764C11.1787 7.70761 11.2424 7.5971 11.3268 7.5033C11.4112 7.40949 11.5144 7.33449 11.6296 7.28314C11.7449 7.2318 11.8697 7.20526 11.9958 7.20526C12.122 7.20526 12.2468 7.2318 12.3621 7.28314C12.4773 7.33449 12.5805 7.40949 12.6649 7.5033C12.7493 7.5971 12.813 7.70761 12.8519 7.82764C12.8909 7.94766 12.9042 8.07453 12.8909 8.20001L12.7609 13.42C12.7609 13.6215 12.6809 13.8149 12.5383 13.9574C12.3958 14.0999 12.2024 14.18 12.0009 14.18C11.7993 14.18 11.606 14.0999 11.4635 13.9574C11.321 13.8149 11.2408 13.6215 11.2408 13.42Z"
                  fill="#fbc02d"
                ></path>{" "}
                <path
                  d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                  stroke="#fbc02d"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
              </g>
            </svg>
            Are you sure you want to {actionType} this bid?
            <div className="d-flex my-4">
              <Button
                color="success"
                onClick={handleBidAction}
                disabled={actionLoading}
              >
                Yes
                {actionLoading && (
                  <Spinner color="white" size="sm" className="ml-2" />
                )}
              </Button>
              <Button
                color="danger"
                className="me-3"
                onClick={confirmationModalToggler}
              >
                No
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={issueModal} toggle={issueModalToggler} centered>
        <ModalHeader className="border-bottom">
          {issueMode === "report" ? "Report" : "View"} Bid Issue
        </ModalHeader>
        <ModalBody>
          <Form id="rejectForm" onSubmit={handleBidIssue}>
            <Label style={{ fontWeight: 600 }}>Issue</Label>
            <Input
              type="textarea"
              rows={4}
              required
              placeholder="Enter bid issue"
              className="Fan_age"
              disabled={issueMode === "view"}
              value={issue}
              onChange={(e) => setIssue(e.target.value)}
            />
          </Form>
          <div className="d-flex justify-content-center mt-4 mb-2">
            <Button
              color="success"
              className="me-3"
              onClick={issueModalToggler}
            >
              {issueMode === "report" ? "Cancel" : "Close"}
            </Button>
            {issueMode === "report" && (
              <Button
                color="danger"
                type="submit"
                form="rejectForm"
                disabled={actionLoading}
              >
                Report
                {actionLoading && (
                  <Spinner color="white" size="sm" className="ml-2" />
                )}
              </Button>
            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={substitution.modal} centered toggle={toggleSubstitution}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You Want To {substitution.accept ? "Accept" : "Reject"} The
              Request.
            </span>
            <br />
            <br />
            <br />
            <Button
              color="primary"
              onClick={handleSubstitution}
              disabled={substitution.btnLoader}
            >
              {substitution.btnLoader ? <Spinner size="sm" /> : "Yes"}{" "}
            </Button>
            <Button color="danger" onClick={toggleSubstitution}>
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Bids;
